import { useEffect } from "react"
import config from "@/config"

const useAppInitializer = () => {
  useEffect(() => {
    console.log("Initializing app...")
    console.log(`Connection to ${config.BACKFLIP_API_BASE}`)
  }, [])
}

export default useAppInitializer
